export class GenDlist {
    public allowExportpdfYn?: number;
    public allowExportxlsYn?: number;
    public allowFilterYn?: number;
    public allowGroupingYn?: number;
    public allowPagingYn?: number;
    public allowSelectionYn?: number;
    public allowTotalbarYn?: number;
    public columnChooserYn?: number;
    public dlistCode: string;
    public dlistName: string;
    public id: number;
    public pageCount?: number;
    public params?: string;
    public showActioncolumnYn?: number;
    public showFilterYn?: number;
    public showGroupingYn?: number;
    public showPagingYn?: number;
    public showSelectionYn?: number;
    public showSettingYn?: number;
    public showTotalbarYn?: number;
    public genDlistColumns: GenDlistColumn[];

    public constructor(item?: any) {
        this.allowExportpdfYn = item.allowExportpdfYn;
        this.allowExportxlsYn = item.allowExportxlsYn;
        this.allowFilterYn = item.allowFilterYn;
        this.allowGroupingYn = item.allowGroupingYn;
        this.allowPagingYn = item.allowPagingYn;
        this.allowSelectionYn = item.allowSelectionYn;
        this.allowTotalbarYn = item.allowTotalbarYn;
        this.columnChooserYn = item.columnChooserYn;
        this.dlistCode = item.dlistCode;
        this.dlistName = item.dlistName;
        this.id = item.id;
        this.pageCount = item.pageCount;
        this.params = item.params;
        this.showActioncolumnYn = item.showActioncolumnYn;
        this.showFilterYn = item.showFilterYn;
        this.showGroupingYn = item.showGroupingYn;
        this.showPagingYn = item.showPagingYn;
        this.showSelectionYn = item.showSelectionYn;
        this.showSettingYn = item.showSettingYn;
        this.showTotalbarYn = item.showTotalbarYn;
        this.genDlistColumns = item.genDlistColumns;
    }
}

export class GenDlistColumn {
    public activeYn: number;
    public allowGroupYn?: number;
    public allowHidingYn?: number;
    public allowSortYn?: number;
    public alooeFilterYn?: number;
    public caption: string;
    public dataField?: string;
    public dataType?: string;
    public dlistId?: number;
    public format?: string;
    public id: number;
    public lookup?: string;
    public orderIndex: number;
    public totalFormula?: string;
    public width: number;
    public genDlist: GenDlist;

    public constructor(item?: any) {
        this.activeYn = item.activeYn;
        this.allowGroupYn = item.allowGroupYn;
        this.allowHidingYn = item.allowHidingYn;
        this.allowSortYn = item.allowSortYn;
        this.alooeFilterYn = item.alooeFilterYn;
        this.caption = item.caption;
        this.dataField = item.dataField;
        this.dataType = item.dataType;
        this.dlistId = item.dlistId;
        this.format = item.format;
        this.id = item.id;
        this.lookup = item.lookup;
        this.orderIndex = item.orderIndex;
        this.totalFormula = item.totalFormula;
        this.width = item.width;
        this.genDlist = item.genDlist;
    }

}

export class GridConditionModel {
  conditionColName: string;
  conditionColSymbol: string;
  conditionColText: any;
  conditionRowColor: string;

  constructor(item?: GridConditionModel) {
    this.conditionColName = item?.conditionColName;
    this.conditionColSymbol = item?.conditionColSymbol;
    this.conditionColText = item?.conditionColText;
    this.conditionRowColor = item?.conditionRowColor;
  }
}

export class GridConditionModelForCss {
  conditionColName: string;
  conditionColSymbol: string;
  conditionColText: any;
  conditionRowStyle: string[];
  conditionRowStyleValue: string[];

  constructor(item?: GridConditionModelForCss) {
    this.conditionColName = item?.conditionColName;
    this.conditionColSymbol = item?.conditionColSymbol;
    this.conditionColText = item?.conditionColText;
    this.conditionRowStyle = item?.conditionRowStyle;
    this.conditionRowStyleValue = item?.conditionRowStyleValue;
  }
}

export class GridConditionModelForColumnCss {
  fieldNames: string[];                  // Hangi kolon(lar)
  conditionColumnStyle: string[];        // CSS property listesi
  conditionColumnStyleValue: string[];   // CSS value listesi

  constructor(item?: GridConditionModelForColumnCss) {
    this.fieldNames = item?.fieldNames || [];
    this.conditionColumnStyle = item?.conditionColumnStyle || [];
    this.conditionColumnStyleValue = item?.conditionColumnStyleValue || [];
  }
}


export class GridHeaderConditionModelForCss {
  fieldNames: string[];
  conditionRowStyle: string[];
  conditionRowStyleValue: string[];

  constructor(item?: GridHeaderConditionModelForCss) {
    this.fieldNames = item?.fieldNames || [];
    this.conditionRowStyle = item?.conditionRowStyle || [];
    this.conditionRowStyleValue = item?.conditionRowStyleValue || [];
  }
}
